
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^((|1)22|146|48|545|577|889)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
